import createVueComponent from '../createVueComponent';

const ArrowUpCircle = createVueComponent('ArrowUpCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'm16 12-4-4-4 4', key: '177agl' }],
  ['path', { d: 'M12 16V8', key: '1sbj14' }],
]);

export default ArrowUpCircle;
